exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lte-1 {\n    fill: #001927;\n  }", ""]);
